import { Inject } from '@odinjs/odin';
import { ContextualBarAPI, FetchAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent, RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { ReactComponent as DownloadSVG } from '../../../resources/assets/commons/download.svg';
import { FragmentNames, VersionFileListAliases } from '../../codegen';
import { VersionFileJson } from '../../interfaces';
import { VersionFile } from '../../interfaces/version';
import { VersionFileService } from '../../services/version-file-service';
import { Utils } from '../../utils';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.VERSION_FILE_LIST })
export default class VersionFileListController extends BaseController {

  @Inject(VersionFileListAliases.FETCH_VERSION_FILE_LIST)
  fetchVersionFileAPI!: FetchAPI;

  @Inject(VersionFileListAliases.CONTEXTUAL_BAR_VERSION_FILE_LIST)
  contextualBarVersionItemAPI!: ContextualBarAPI;

  id!: string | number;

  @OnMount({ target: VersionFileListAliases.FETCH_VERSION_FILE_LIST })
  onMountFetchVersionFileList(): void {
    this.id = this.getPathId('versionId');
    this.fetchVersionFileAPI.setParameters({
      versionId: this.id,
    });
  }

  @OnAfterFetch({ target: VersionFileListAliases.FETCH_VERSION_FILE_LIST })
  onAfterFetchModule(event: FetchEvent): void {
    const data = (event.data as Array<VersionFileJson>);
    if (event.data) {
      const title = MessageService.translate('version.file-title')
        .replace('#@VERSION_NUMBER#@', data[0].versionNumber);
      this.contextualBarVersionItemAPI.setTitle(title);
    }
  }

  @OnDynamicContentRender(VersionFileListAliases.TABLE_VERSION_ITEM_FILE)
  onRenderTableVersion(event: RenderEvent): void {
    if (event.entry === 'actions') {
      event.render((data: VersionFile) => {
        return Utils.renderActionButtons([
          { title: 'product-manual.download', onClick: () => this.download(data), icon: DownloadSVG },
        ]);
      });
    }
  }

  download(data: VersionFile): void {
    ModalService.openDialog({
      id: 'download-modal',
      fragment: 'download-modal',
      closeable: false,
    });

    VersionFileService.download(data.id, data.name)
      .catch(console.error)
      .finally(() => {
        ModalService.close('download-modal');
      });
  }

}
